module.exports = __webpack_public_path__ + "img/note.f84b0cd0.svg";